<div [class.mb-2]="selectedOptions?.length > 0" class="api-select-tag-control">
  <ng-container>
    <mat-spinner *ngIf="isInitialLoading$ | async" diameter="25"></mat-spinner>
    <ng-container *ngIf="selectedOptions">
      <div class="tag-container">
        <button class="tag no-hover" *ngFor="let option of selectedOptions">
          <label class="tag-label">{{ option.label }}</label>
          <button class="tag-close" (click)="removeOption(option.id)">
            <svg-icon key="cancel" class="close-icon"></svg-icon>
          </button>
        </button>
      </div>
    </ng-container>
  </ng-container>

  <mat-form-field>
    <mat-select
      (valueChange)="addOption($event)"
      [placeholder]="(isLoading$ | async) ? 'Loading...' : placeholder"
      [errorStateMatcher]="errorLabel !== undefined ? alwaysError : undefined"
      [disabled]="formControl.disabled || (isLoading$ | async)"
      (closed)="propagateTouch()"
      [attr.data-testid]="testId"
    >
      <ng-container>
        <mat-option>
          <ngx-mat-select-search
            [formControl]="filterControl"
            [noEntriesFoundLabel]="filterNoEntriesFoundLabel"
            [placeholderLabel]="(isLoading$ | async) ? 'Loading...' : filterPlaceholderLabel"
            data-testid="multi-select-search-input"
          >
            <svg-icon ngxMatSelectSearchClear key="cancel"></svg-icon>
          </ngx-mat-select-search>
        </mat-option>
        <ng-container *ngIf="availableOptions?.length">
          <mat-option
            *ngFor="let option of availableOptions"
            [value]="option"
            [class.d-none]="!availableOptions.includes(option)"
            [attr.data-testid]="testId + '-option-' + option.label"
          >
            {{ option.label }}
          </mat-option>
        </ng-container>
        <mat-option *ngIf="isFilterLoading$ | async">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
      </ng-container>
    </mat-select>
    <mat-label *ngIf="label">{{ label }}</mat-label>
    <mat-error *ngIf="errorLabel !== undefined">{{ errorLabel }}</mat-error>
    <mat-hint *ngIf="hintLabel">{{ hintLabel }}</mat-hint>
  </mat-form-field>
</div>
